import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Box, MenuItem, MenuItemProps} from '@mui/material';
import {MouseEvent, ReactNode} from 'react';

import {
  buildHistoryReportUrl,
  HistoryReportExtraParams,
  HistoryReportId,
} from '../../utils/historyReportUrl';
import {DashboardHistoryReportType} from '../dashboard-panels/DashboardPanelItem';

type Props = Omit<MenuItemProps, 'onClick' | 'id'> & {
  type: DashboardHistoryReportType;
  id?: HistoryReportId | null;
  extra?: HistoryReportExtraParams;
  onOpen?: () => void;
  onAfterAction?: () => void;
  children: ReactNode;
};

const HistoryReportMenuItem = ({
  type,
  id,
  extra,
  onOpen,
  onAfterAction,
  children,
  ...menuItemProps
}: Props) => {
  const handleItemClick = () => {
    onOpen?.();
    onAfterAction?.();
  };

  const handleNewTabClick = (event: MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    if (id === undefined || id === null) {
      return;
    }
    const url = buildHistoryReportUrl(type, id, extra);
    window.open(url, '_blank', 'noopener,noreferrer');
    onAfterAction?.();
  };

  return (
    <MenuItem {...menuItemProps} onClick={handleItemClick}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        gap={1}
      >
        <span>{children}</span>
        {id !== undefined && id !== null ? (
          <OpenInNewIcon
            fontSize="small"
            onClick={handleNewTabClick}
            aria-label="Open in new tab"
            sx={{cursor: 'pointer', color: 'text.secondary'}}
          />
        ) : null}
      </Box>
    </MenuItem>
  );
};

export default HistoryReportMenuItem;
